/**
 * 앱 플레이버 — fna.m.caion.kr 영수증 전용
 */
export function isFnaFlavor(): boolean {
  if (typeof process !== 'undefined' && process.env?.VUE_APP_FLAVOR === 'fna') {
    return true
  }
  if (typeof window === 'undefined') return false
  const host = String(window.location.hostname || '').toLowerCase()
  return host === 'fna.m.caion.kr' || host.startsWith('fna.m.')
}

export const FNA_APP_NAME = '카이온 영수증'
export const FNA_HOME = '/fna'
export const FNA_RECEIPTS = '/fna'
export const FNA_SCAN = '/fna/scan'
